import React, { PropsWithChildren } from "react";

import { Flex } from "@chakra-ui/react";

import { useCrudListContext } from "./CrudListContext";
import { CrudListCreateLink } from "./CrudListCreateLink";
import { CrudListError } from "./CrudListError";
import { CrudListFilterBar } from "./CrudListFilterBar";
import { CrudListRefreshButton } from "./CrudListRefreshButton";
import { CrudListSearchBar } from "./CrudListSearchBar";

export interface CrudListHeaderProps {
  hideCreateLink?: boolean;
  hideError?: boolean;
  hideRefresh?: boolean;
  hideSearchBar?: boolean;
  hideFilterBar?: boolean;
  hideAdvancedFilters?: boolean;
  isCreateDisabled?: boolean;
  filterLabels?: {
    supplier: string;
    total: string;
    dateFrom: string;
    dateTo: string;
  };
}

export function CrudListHeader({
  children,
  hideCreateLink,
  hideError,
  hideRefresh,
  hideSearchBar,
  hideFilterBar = true,
  hideAdvancedFilters = false,
  isCreateDisabled = false,
  filterLabels
}: PropsWithChildren<CrudListHeaderProps>) {
  const { statusCounts, lastChosenStatus } = useCrudListContext();

  return (
    <React.Fragment>
      {!hideError && <CrudListError />}
      <Flex flexDirection="column" gap={4} width="100%">
        <Flex
          alignItems="flex-end"
          flexFlow="row nowrap"
          gap={4}
          justifyContent="flex-start"
        >
          {!hideSearchBar && <CrudListSearchBar />}
          {!hideFilterBar && (
            <CrudListFilterBar
              filterLabels={filterLabels}
              statusCounts={statusCounts || {}}
              lastChosenStatus={lastChosenStatus || ""}
              hideAdvancedFilters={hideAdvancedFilters}
            />
          )}
          {children}
          {(!hideRefresh || !hideCreateLink) && (
            <Flex
              alignItems="center"
              flexFlow="row nowrap"
              gap={4}
              justifyContent="flex-start"
              marginLeft="auto"
            >
              {!hideRefresh && (
                <CrudListRefreshButton flex="0 0 max-content" height="40px" />
              )}
              {!hideCreateLink && (
                <CrudListCreateLink
                  flex="0 0 max-content"
                  isDisabled={isCreateDisabled}
                />
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </React.Fragment>
  );
}
